export const DEFAULT_DATE_FORMAT = "DD MMM YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD MMM YYYY";
export const EMPTY_DATE_DISPLAY = "-";

function getYearFromString(value) {
  const text = String(value).trim();
  const leadingYear = text.match(/^(\d{4})(?:[-/]|$)/);
  if (leadingYear) return Number(leadingYear[1]);

  const trailingYear = text.match(/[-/](\d{4})(?:\s|T|$)/);
  if (trailingYear) return Number(trailingYear[1]);

  return null;
}

function isMidnight(date) {
  return (
    typeof date.hour === "function" &&
    typeof date.minute === "function" &&
    typeof date.second === "function" &&
    typeof date.millisecond === "function" &&
    date.hour() === 0 &&
    date.minute() === 0 &&
    date.second() === 0 &&
    date.millisecond() === 0
  );
}

function getDateOnlyFormat(format) {
  const dateOnlyFormat = format
    .replace(/\s*\([^)]*[Hh]{1,2}:mm(?::ss)?(?:\s*A)?[^)]*\)/g, "")
    .replace(/\s*,?\s*[Hh]{1,2}:mm(?::ss)?(?:\s*A)?/g, "")
    .trim();

  return dateOnlyFormat || DEFAULT_DATE_FORMAT;
}

export function isPlaceholderDate(value) {
  if (!value) return true;

  if (value instanceof Date) {
    return value.getFullYear() === 1;
  }

  const year = getYearFromString(value);
  return year === 1;
}

export function formatDate(value, momentFactory, options = {}) {
  if (!value || isPlaceholderDate(value) || !momentFactory) {
    return EMPTY_DATE_DISPLAY;
  }

  const format = options.format || DEFAULT_DATE_TIME_FORMAT;
  const date = options.parseFormat
    ? momentFactory(value, options.parseFormat)
    : momentFactory(value);

  if (!date || (typeof date.isValid === "function" && !date.isValid())) {
    return EMPTY_DATE_DISPLAY;
  }

  if (typeof date.year === "function" && date.year() === 1) {
    return EMPTY_DATE_DISPLAY;
  }

  return date.format(isMidnight(date) ? getDateOnlyFormat(format) : format);
}
